/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
/* eslint-disable react/no-array-index-key */
import React, {
  ChangeEvent,
  forwardRef,
  ForwardRefRenderFunction,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import {
  GridContextProvider,
  GridDropZone,
  GridItem,
  swap,
} from 'react-grid-dnd';
import { HiPlus } from 'react-icons/hi';
import { MdUpload } from 'react-icons/md';
import { IoMdClose, IoIosShareAlt } from 'react-icons/io';
import Swal from 'sweetalert2';
import * as Yup from 'yup';
import { BsChatRightText } from 'react-icons/bs';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';

import { AxiosResponse } from 'axios';
import Toast from '~/utils/toast';
import api from '~/services/api';
import getValidationErros from '~/utils/getValidationsErrors';

import { Container, Modal } from './styles';
import { KrClose, KrEdit, KrTrash } from '~/components/KoroIcons';
import Input from '~/components/Input';
import Select, { IOption } from '~/components/Select';
import Loading from '~/components/Loading';

interface ISponsor {
  id: number;
  name: string;
}

interface IFile {
  id?: number;
  name: string;
  url: string;
  size?: number;
  file?: File;
  isNew?: boolean;
}

export interface ICard {
  id: number;
  sponsor_id: number;
  name: string;
  description: string;
  link: string;
  file: IFile;
  isNew?: boolean;
}

interface IFormData {
  id: number;
  sponsor: string;
  description: string;
  link: string;
}

interface ISponsorsProps {
  initialData?: ICard[];
  event_id: number;
  onChange(data: ICard[]): void;
}

export interface ISponsorsHandle {
  submit: () => void;
}

const Sponsors: ForwardRefRenderFunction<ISponsorsHandle, ISponsorsProps> = (
  { initialData, event_id, onChange },
  ref
) => {
  const sponsorsFormRef = useRef<FormHandles | null>(null);
  const formRef = useRef<FormHandles | null>(null);
  const [files, setFiles] = useState<File[]>([]);
  const [oldFile, setOldFile] = useState({} as IFile);
  const [cardsSponsors, setCardsSponsors] = useState<ICard[]>([]);
  const [oldCardsSponsors, setOldCardsSponsors] = useState<ICard[]>([]);
  const [show, setShow] = useState(false);
  const [sponsors, setSponsors] = useState<IOption[]>([]);
  const [sponsorSelected, setSponsorSelected] = useState({} as IFormData);
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState('Carregando...');

  const handleLoadSponsors = useCallback(async (search?: string) => {
    const response = await api.get<ISponsor[]>('sponsors', {
      params: {
        sponsor: search,
      },
    });
    const data = response.data.map<IOption>((sponsor) => ({
      id: sponsor.id,
      value: sponsor.name,
      selected: false,
    }));

    setSponsors(data.sort((a, b) => a.value.localeCompare(b.value)));
  }, []);

  useEffect(() => {
    if (initialData) {
      setCardsSponsors(initialData);
      setOldCardsSponsors(JSON.parse(JSON.stringify(initialData)));
    }
  }, [initialData]);

  useEffect(() => {
    handleLoadSponsors();
  }, [handleLoadSponsors]);

  const handleClose = useCallback(() => {
    setShow(false);
    setFiles([]);
    setOldFile({} as IFile);
    setSponsorSelected({} as IFormData);
    setSponsors((oldState) => {
      return oldState.map((sponsor) => {
        return {
          ...sponsor,
          selected: false,
        };
      });
    });
  }, []);

  const handleDropColor = useCallback(
    (event: React.DragEvent<HTMLLabelElement>) => {
      event.preventDefault();
      const { files: filesData } = event.dataTransfer;
      if (filesData) {
        if (
          filesData[0].type !== 'image/jpeg' &&
          filesData[0].type !== 'image/png' &&
          filesData[0].type !== 'image/svg+xml'
        ) {
          Swal.fire({
            icon: 'error',
            iconColor: '#ff6900',
            confirmButtonColor: '#ff6900',
            title: 'Formato inválido',
            text: 'O arquivo deve ser do formato JPG, JPEG, PNG ou SVG',
          });
        } else if (filesData[0].size > 50000) {
          Swal.fire({
            icon: 'error',
            iconColor: '#ff6900',
            confirmButtonColor: '#ff6900',
            title: 'Arquivo muito grande',
            text: 'O tamanho do arquivo deve ser menor que 50KB',
          });
        } else {
          setFiles(Array.from(filesData));
          setOldFile({} as IFile);
        }
      }
    },
    []
  );

  const handleDragOver = useCallback(
    (event: React.DragEvent<HTMLLabelElement>) => {
      event.preventDefault();
    },
    []
  );

  const handleChangeFile = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const { files: filesData } = event.target;
      if (filesData) {
        if (
          filesData[0].type !== 'image/jpeg' &&
          filesData[0].type !== 'image/png' &&
          filesData[0].type !== 'image/svg+xml'
        ) {
          Swal.fire({
            icon: 'error',
            iconColor: '#ff6900',
            confirmButtonColor: '#ff6900',
            title: 'Formato inválido',
            text: 'O arquivo deve ser do formato JPG, JPEG, PNG ou SVG',
          });
        } else if (filesData[0].size > 50000) {
          Swal.fire({
            icon: 'error',
            iconColor: '#ff6900',
            confirmButtonColor: '#ff6900',
            title: 'Arquivo muito grande',
            text: 'O tamanho do arquivo deve ser menor que 50KB',
          });
        } else {
          setFiles(Array.from(filesData));
          setOldFile({} as IFile);
        }
      }
    },
    []
  );

  const handleDeleteCard = useCallback(
    (card_id) => {
      Swal.fire({
        icon: 'warning',
        iconColor: '#ff6900',
        title: 'Gostaria de excluir o Patrocinador?',
        showCancelButton: true,
        cancelButtonText: 'Não',
        confirmButtonText: 'Sim',
        confirmButtonColor: '#ff6900',
        cancelButtonColor: '#B34A00',
        reverseButtons: true,
      }).then((e) => {
        if (e.isConfirmed) {
          Toast.fire({
            icon: 'success',
            iconColor: '#ff6900',
            title: 'Patrocinador excluído com sucesso!',
          });

          const newCardSponsor = cardsSponsors.filter(
            (card) => card.id !== card_id
          );

          setCardsSponsors(newCardSponsor);
        }
      });
    },
    [cardsSponsors]
  );

  const handleDeleteImg = useCallback((indexToDelete) => {
    setFiles((prevFiles) =>
      prevFiles.filter((_, index) => index !== indexToDelete)
    );
    const input = document.getElementById('files') as HTMLInputElement;
    if (input) input.value = '';
  }, []);

  const handleDeleteFile = useCallback(() => {
    setOldFile({} as IFile);
  }, []);

  const handleSubmitSponsors = useCallback(async () => {
    if (loading) return;
    try {
      setLoading(true);
      setLoadingText('Salvando...');
      const deletedSponsorsEvents = oldCardsSponsors.filter(
        (cardSponsor) =>
          !cardsSponsors.some(
            (cardSponsorData) => cardSponsor.id === cardSponsorData.id
          )
      );

      if (deletedSponsorsEvents.length > 0) {
        for (const sponsorEvent of deletedSponsorsEvents) {
          await api.delete(`sponsors-events/${sponsorEvent.id}`);
        }
      }

      // const oldFiles = new Set(
      //   oldCardsSponsors
      //     .map((cardSponsor) => cardSponsor.file?.id)
      //     .filter((id): id is number => id !== undefined)
      // );

      // const newFiles = new Set(
      //   cardsSponsors
      //     .map((cardSponsor) => cardSponsor.file?.id)
      //     .filter((id): id is number => id !== undefined)
      // );

      // const filesDeleted = Array.from(oldFiles).filter(
      //   (id) => !newFiles.has(id)
      // );

      // if (filesDeleted.length > 0) {
      //   for (const id of filesDeleted) {
      //     await api.delete(`archives/${id}`);
      //   }
      // }

      const newCardsSponsors = JSON.parse(
        JSON.stringify(cardsSponsors)
      ) as ICard[];

      if (cardsSponsors.length > 0) {
        let order = 1;
        let index = 0;
        for (const sponsorEvent of cardsSponsors) {
          let archive_id = sponsorEvent.file.id;

          if (sponsorEvent.file.isNew) {
            const formData = new FormData();
            formData.append('file', sponsorEvent.file.file as File);
            const responseArchive = await api.post('archives', formData);
            archive_id = responseArchive.data.id;
            newCardsSponsors[index].file.id = responseArchive.data.id;
            newCardsSponsors[index].file.url = responseArchive.data.archive_url;
            newCardsSponsors[index].file.isNew = false;
          }

          const sponsorEventFormData = {
            sponsor_id: sponsorEvent.sponsor_id,
            event_id,
            archive_id,
            description: sponsorEvent.description,
            link: sponsorEvent.link,
            order,
          };

          let response: AxiosResponse;
          if (sponsorEvent.isNew) {
            response = await api.post(`sponsors-events`, sponsorEventFormData);
          } else {
            response = await api.put(
              `sponsors-events/${sponsorEvent.id}`,
              sponsorEventFormData
            );
          }

          newCardsSponsors[index].id = response.data.id;
          newCardsSponsors[index].isNew = false;
          index += 1;
          order += 1;
        }
      }

      setCardsSponsors(newCardsSponsors);
      setOldCardsSponsors(JSON.parse(JSON.stringify(newCardsSponsors)));
      onChange(newCardsSponsors);
    } catch (error) {
      Swal.fire('Opss...', 'Ocorreu um erro ao salvar', 'error');
    } finally {
      setLoading(false);
      setLoadingText('Carregando...');
    }
  }, [loading, oldCardsSponsors, cardsSponsors, onChange, event_id]);

  const handleSubmit = useCallback(
    async (data: IFormData) => {
      try {
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          sponsor: Yup.string().required('O patrocinador é obrigatório'),
          description: Yup.string(),
          link: Yup.string().url('Coloque uma URL válida'),
          files: Yup.string().test(
            'validLogo',
            `A imagem é obrigatória`,
            () => {
              return files.length > 0 || Object.keys(oldFile).length > 0;
            }
          ),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        const sponsorOptionSelected = sponsors.find(
          (sponsor) => sponsor.selected
        );

        const sponsorFormData = {
          name: sponsorOptionSelected?.value || '',
          description: data.description,
          link: data.link,
          isNew: Object.keys(sponsorSelected).length === 0,
        };

        const newCardsSponsors = cardsSponsors.slice();
        if (Object.keys(sponsorSelected).length > 0) {
          const cardsSponsorsIndex = newCardsSponsors.findIndex(
            (card) => card.id === sponsorSelected.id
          );

          if (cardsSponsorsIndex >= 0) {
            if (files.length > 0) {
              newCardsSponsors[cardsSponsorsIndex].file = {
                id: new Date().getTime(),
                name: files[0].name,
                size: files[0].size,
                url: URL.createObjectURL(files[0]),
                file: files[0],
                isNew: true,
              };
              newCardsSponsors[cardsSponsorsIndex].isNew = true;
            }

            newCardsSponsors[cardsSponsorsIndex] = {
              ...newCardsSponsors[cardsSponsorsIndex],
              ...sponsorFormData,
            };
          }
        } else {
          newCardsSponsors.push({
            id: new Date().getTime(),
            sponsor_id: (sponsorOptionSelected?.id as number) || 0,
            ...sponsorFormData,
            file: {
              id: new Date().getTime(),
              name: files[0].name,
              size: files[0].size,
              url: URL.createObjectURL(files[0]),
              file: files[0],
              isNew: true,
            },
          });
        }

        setCardsSponsors(newCardsSponsors);

        handleClose();
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErros(error);
          formRef.current?.setErrors(errors);
        } else {
          Swal.fire('Oops...', 'Ocorreu um erro tente novamente!');
        }
      }
    },
    [cardsSponsors, files, handleClose, oldFile, sponsorSelected, sponsors]
  );

  const handleEditSponsor = useCallback((sponsor: ICard) => {
    setShow(true);
    setSponsorSelected({
      id: sponsor.id,
      sponsor: sponsor.sponsor_id.toString(),
      description: sponsor.description,
      link: sponsor.link,
    });
    setSponsors((oldState) =>
      oldState.map((sponsorData) => {
        if (sponsorData.id === sponsor.sponsor_id) {
          return {
            ...sponsorData,
            selected: true,
          };
        }
        return sponsorData;
      })
    );
    setOldFile({
      id: sponsor.file.id,
      name: sponsor.file.name,
      size: sponsor.file.size,
      url: sponsor.file.url,
    });
  }, []);

  const handleChange = useCallback(
    (_, sourceIndex: number, targetIndex: number) => {
      const updatedSponsors = swap(cardsSponsors, sourceIndex, targetIndex);
      setCardsSponsors(updatedSponsors);
    },
    [cardsSponsors]
  );

  const handleClickSubmit = useCallback(() => {
    if (formRef.current) {
      formRef.current.submitForm();
    }
  }, []);

  const handleSelectSponsor = useCallback(
    (sponsor) => {
      const newSponsors = sponsors.map((s) => ({
        ...s,
        selected: s.id === sponsor.id,
      }));
      setSponsors(newSponsors);
    },
    [sponsors]
  );

  useImperativeHandle(
    ref,
    () => ({
      submit: () => {
        sponsorsFormRef.current?.submitForm();
      },
    }),
    []
  );

  const handleFilterSponsors = useCallback(
    (value: string) => {
      handleLoadSponsors(value);
    },
    [handleLoadSponsors]
  );

  return (
    <Container
      ref={sponsorsFormRef}
      onSubmit={handleSubmitSponsors}
      className="row justify-content-center"
    >
      <div className="col-lg-11 col-xl-10">
        <h2 className="h4 fw-semibold text-center mt-5 mb-4">
          3 - Patrocinadores
        </h2>
        <p className="mb-4">
          Cadastrar patrocinadores para o seu evento, caso não queira cadastrar
          patrocinadores clicar em próximo.
        </p>
      </div>

      <div className="col-lg-3 col-xxl-3 px-2 mt-3">
        <button
          type="button"
          onClick={() => setShow(true)}
          className="w-100 h-100 btn-add py-5"
        >
          <HiPlus size={24} color="#ff6900" className="me-2" />
          <span className="d-block">Adicionar Patrocinador</span>
        </button>
      </div>
      <div className="col-lg-9 col-xxl-9 px-2 mt-3">
        <div className="row">
          <GridContextProvider onChange={handleChange}>
            <GridDropZone
              id="questions"
              boxesPerRow={3}
              rowHeight={320}
              style={{
                borderRadius: '8px',
                minHeight: Math.ceil(cardsSponsors.length / 3) * 320,
              }}
            >
              {cardsSponsors.map((sponsor) => (
                <GridItem key={sponsor.id} className="grab">
                  <div className="cards-sponsor pb-3 mx-2">
                    <div className="card bg-white p-4">
                      <div className="d-flex justify-content-end">
                        {sponsor.description && (
                          <button
                            type="button"
                            className="border-0 rounded-circle bg-gray me-2 position-relative"
                          >
                            <span
                              className="tooltip-total"
                              data-tooltip={`Texto patrocinador: ${sponsor.description}`}
                            >
                              <BsChatRightText size={16} color="#fff" />
                            </span>
                          </button>
                        )}
                        <button
                          type="button"
                          className="border-0 rounded-circle bg-gray me-2"
                          onClick={() => handleEditSponsor(sponsor)}
                        >
                          <KrEdit size={16} color="#fff" />
                        </button>
                        <button
                          type="button"
                          className="border-0 rounded-circle bg-gray"
                          onClick={() => handleDeleteCard(sponsor.id)}
                        >
                          <KrTrash size={16} color="#fff" />
                        </button>
                      </div>

                      <img
                        src={sponsor.file.url}
                        alt="Logo patrocinador"
                        className="w-100 my-3"
                      />

                      <p>{sponsor.name}</p>
                      <span>
                        <a
                          className={`${
                            !sponsor.link ? 'pe-none opacity-50' : ''
                          } link-ext d-inline-flex align-items-center`}
                          href={sponsor.link}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Link externo{' '}
                          <span className="ms-2">
                            <IoIosShareAlt size={16} color="#fff" />
                          </span>
                        </a>
                      </span>
                    </div>
                  </div>
                </GridItem>
              ))}
            </GridDropZone>
          </GridContextProvider>
        </div>
      </div>

      <Modal
        className="modal-filter"
        size="lg"
        centered
        show={show}
        onHide={handleClose}
      >
        <Form
          ref={formRef}
          onSubmit={handleSubmit}
          initialData={sponsorSelected}
        >
          <Modal.Header className="justify-content-between align-items-center border-0 px-3 px-sm-5 pb-0 pt-0">
            <Modal.Title className="mb-0 mt-4">
              <h2 className="title mb-0">Adicionar Patrocinador</h2>
            </Modal.Title>
            <button
              type="button"
              onClick={handleClose}
              className="border-0 bg-transparent"
            >
              <KrClose size={20} color="#989898" />
            </button>
          </Modal.Header>
          <Modal.Body className="pt-0 px-3 px-sm-5">
            <div className="row">
              <div className="col-12">
                <hr />
              </div>

              <>
                <div className="col-12">
                  <span className="h6 fw-normal mt-3 d-block">
                    Nome do patrocinador:
                  </span>
                  <Select
                    name="sponsor"
                    placeholder="Selecione o patrocinador"
                    className="select"
                    options={sponsors}
                    onChange={handleSelectSponsor}
                    onChangeText={handleFilterSponsors}
                  />
                  <span className="h6 fw-normal mt-3 d-block">
                    Texto do patrocinador: (Opcional)
                  </span>
                  <Input type="text" name="description" />
                  <span className="h6 fw-normal mt-3 d-block">
                    URL do patrocinador: (Opcional)
                  </span>
                  <Input
                    type="url"
                    name="link"
                    placeholder="https://patrocinador.com.br"
                  />
                  <span className="h6 fw-normal mt-3 d-block">
                    IMG do patrocinador:
                  </span>
                  <label
                    htmlFor="files"
                    className="w-100 label-modal text-center"
                    onDrop={handleDropColor}
                    onDragOver={handleDragOver}
                  >
                    <MdUpload size={48} color="#FF6900" />
                    <span className="d-block">
                      Arraste e solte o arquivo aqui
                    </span>
                    <span className="d-inline-flex my-2">Selecionar</span>
                    <span className="d-block">
                      Extensões aceitas: jpg, png, jpeg.
                    </span>
                    <span className="d-block">
                      O tamanho do arquivo deve ser menor que 50KB
                    </span>
                  </label>
                  <Input
                    id="files"
                    type="file"
                    name="files"
                    className="d-none"
                    onChange={(e) => handleChangeFile(e)}
                  />
                  {Object.keys(oldFile).length > 0 && (
                    <div className="d-flex justify-content-between arquives p-3 mt-3">
                      <div className="d-flex align-items-center">
                        <img src={oldFile.url} alt={oldFile.name} />
                        <p className="ms-3 mb-0">
                          {oldFile.name}
                          <br />
                          {oldFile.size
                            ? `${Math.round(oldFile.size / 1024)} KB`
                            : ''}
                        </p>
                      </div>
                      <button
                        type="button"
                        className="bg-transparent border-0"
                        onClick={handleDeleteFile}
                      >
                        <IoMdClose size={24} color="#8C8C8C" />
                      </button>
                    </div>
                  )}
                  {files.map((file, index) => (
                    <div
                      key={file.name}
                      className="d-flex justify-content-between arquives p-3 mt-3"
                    >
                      <div className="d-flex align-items-center">
                        <img src={URL.createObjectURL(file)} alt={file.name} />
                        <p className="ms-3 mb-0">
                          {file.name}
                          <br />
                          {Math.round(file.size / 1024)} KB
                        </p>
                      </div>
                      <button
                        type="button"
                        className="bg-transparent border-0"
                        onClick={() => handleDeleteImg(index)}
                      >
                        <IoMdClose size={24} color="#8C8C8C" />
                      </button>
                    </div>
                  ))}
                </div>
              </>
            </div>
          </Modal.Body>
          <Modal.Footer className="border-0 pb-4 px-5">
            <button
              type="button"
              onClick={handleClickSubmit}
              className="mx-auto btn-filter d-flex align-items-center justify-content-center btn h6 fw-normal py-2 px-4 mt-2 mb-0"
            >
              Confirmar
            </button>
          </Modal.Footer>
        </Form>
      </Modal>
      <Loading active={loading} text={loadingText} />
    </Container>
  );
};

export default forwardRef(Sponsors);
